import { Component, Input } from '@angular/core';
import { IconComponent } from '@nagel-assests';

@Component({
    selector: 'lib-disabled-overlay',
    imports: [
        IconComponent
    ],
    templateUrl: './disabled-overlay.component.html',
    styleUrl: './disabled-overlay.component.scss',
})
export class DisabledOverlayComponent {}
